fx.translations("en", {
    "Ajouter 2 pages" : "Add 2 pages",
    "Supprimer 2 pages" : "Delete 2 pages",
    "Votre album ne peut contenir moins de $ pages" : "Your album cannot contain fewer than $ pages",
    "Copier" : "Copy", 
    "Couper" : "Cut",
    
    "Nombre de photos par page" : "Number of photos per page",
    
    "Tout sélectionner" : "Select all",
    "Tout déselectionner" : "Deselect all",
    
    "Si rien ne ne se passe après avoir cliqué sur le bouton de connexion, cela signifie que votre navigateur bloque les popups. Il vous suffit d'autoriser votre navigateur à afficher les popups pour résoudre le problème." : "If nothing happens after clicking the login button, it means your browser is blocking pop-ups. Simply allow your browser to show pop-ups to solve the problem.",
    "Nous avons bientôt fini de récupérer vos photos" : "We will soon finish retrieving your photos",
    "On s’occupe de vous rediriger quand c’est terminé" : "We will take care of redirecting you when it's finished",
   
    "Cliquez pour aller à la page" : "Click to go to the page",
    
    "Souhaitez-vous commander votre ouvrage dans l'état ?" : "Do you want to order your book as it is?",
  
    "La couverture a été changée" : "The cover has been changed",
    "Vérifier que tout est placé correctement sur votre couverture." : "Check that everything is placed correctly on your cover.",
    
    "Ce changement de couverture n'est pas possible" : "This cover change is not possible",
    "mais avec cette couverture votre album ne peut contenir <strong>plus de $ pages</strong>.<br><br> Veuillez supprimer des pages avant de choisir cette couverture." : "but with this cover your album can not contain <strong>more than $ pages</strong>. Please delete pages before choosing this cover.",
    "mais avec cette couverture votre album doit contenir <strong>au moins $ pages</strong>.<br><br> Veuillez ajouter des pages avant de choisir cette couverture." : "but with this cover your album must contain <strong>at least $ pages</strong>. Please add pages before choosing this cover.",
    "J'ajoutes vos photos dans votre gallerie" : "I add your photos to your gallery",
    "Souhaitez-vous que je crée votre album photo ?" : "Would you like me to create your photo album?",
    "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Your photos will be placed in chronological order,<br>and you will just have to check your album.",
    "Attention : votre contenu sera totalement remplacé." : "Warning: your content will be completely replaced.",
    "Oui, Créez mon album" : "Yes, create my album",
    "Non, merci" : "No, thank you",
    "Un instant, je place vos photos..." : "One moment, I am placing your photos...",
    "Cet aperçu vous montre comment sera votre album une fois imprimé.<br/>Assurez-vous de n'avoir rien oublié avant de commander." : "This preview shows you what your album will look like once printed.<br/>Make sure you haven't forgotten anything before ordering.",
    "L'aperçu de votre album est prêt !" : "Your album preview is ready!",
    "Assurez-vous de n'avoir rien oublié avant de commander." : "Make sure you haven't forgotten anything before ordering.",
    "Vérifier mon album" : "Check my album",
    "J'ai préparé l'aperçu de votre album" : "I have prepared the preview of your album",
    "Voir l'aperçu" : "View the preview",
    
    "Continuer" : "Continue",

    "Copie en cours" : "Copying in progress",
    "Ca va être rapide !" : "It's going to be quick!",
    
    "Choisissez la finition de votre album" : "Choose the finish of your album",
    "Quel type d'ouverture souhaitez-vous ?" : "What type of opening would you like?",
    
    "Choisissez la forme de votre album" : "Choose the shape of your album",

    "Votre album sera bientôt accessible" : "Your book will be available soon",
    "Il est en cours d'envoi vers nos imprimantes." : "We are transmitting it to our printers",
   
    "Grille activée" : "Grid enabled",
    "Grille désactivée" : "Grid disabled",
    "La grille de repère est maintenant activée" : "The guide grid is now enabled",
    "La grille de repère est maintenant désactivée" : "The guide grid is now disabled",
    "Epaisseur" : "Thickness",

    "Vue Globale" : "Global View",
    "Vue Edition" : "Edit View",

    "Editer" : "Edit",
    "Prévisualiser" : "Preview",

    "Aller directement à l'éditeur" : "Go directly to the editor",
    "$ photos sélectionnées" : "$ photos selected",
    "Suivant" : "Next",
     
    "Sélectionner les meilleures !" : "Select the best ones!",
    "Tout sélectionner" : "Select all",
    "J'ai sélectionné vos photos" : "I have selected your photos",
    "Vous pouvez modifier ma sélection avant de lancer la création intelligente de votre album" : "You can modify my selection before starting the smart creation of your album",
    "Créer votre album !" : "Create your album!",
     
    "Votre fichier a été importé" : "Your file has been imported",
    "Il a été ajouté à vos photos" : "It has been added to your photos",

    "Les photos ont bien été téléchargées depuis votre mobile" : "The photos have been successfully downloaded from your mobile",
    "Téléchargement des photos mobile terminé !" : "Mobile photo download complete!",

    "Options" : "Options",

    "+ $ €" : "+ $ €",

    "Couvertures" : "Covers",
    "Thèmes" : "Themes",
     
    "Mises en page" : "Layouts",
     
    "Vue Simple" : "Simple View",
    "Changer la couverture" : "Change the cover",
     
    "Sauvegarder en tant que Modèle" : "Save this layout",

    "Numéroter les pages" : "Number the pages",
    "Supprimer la numérotation" : "Remove numbering",
     
    "J'ai numéroté vos pages" : "I have numbered your pages",
    "Cliquez pour éditer la taille, la police et la couleur" : "Click to edit size, font, and color",
    "Ok" : "Ok",

    "Changer de modèle" : "Change model",

    "Choisissez la finition de votre album" : "Choose the finish of your album",

    "Thématique" : "Recommended",
    "Classique" : "Classic",
    "Sauvegardé" : "Custom",

    "Nombre de photos" : "Number of photos",

    "Placer vos photos automatiquement" : "Place your photos automatically",
    "Mises en pages" : "Layouts",

    // album preview (desktop.common.preview.BookTable)
    "Dos" : "Back cover",
    "Votre album" : "Your album",
    "Retour à l'éditeur" : "Back to the editor",
    "Vue de face" : "Top view",
    "Vue perspective" : "Perspective view",
    "Page précédente" : "Previous page",
    "Page suivante" : "Next page",
    "Pagination" : "Pagination",
    "Vue" : "View",
    "Aperçu de votre album" : "Preview of your album",
});
